<template>
  <div class="general-frame">
    <div class="general-neick" style="position: relative;">
      <div class="general-search-bar">
        <div
          class="customButton"
          v-for="item in dateQuery"
          @click="timeSelection(item.value)"
          :class="params.range === item.value ? 'border-end':''"
        >{{item.name}}</div>
        <el-date-picker
          v-show=" params.range === 'day'"
          v-model="timeQuery.a"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="trigger()"
          @focus="timeQuery = {}"
        ></el-date-picker>
        <el-date-picker
          v-show=" params.range === 'week'"
          v-model="timeQuery.b"
          type="week"
          format="yyyy 第 WW 周"
          value-format="yyyy-MM-dd"
          placeholder="请选择周数"
          :picker-options="pickerOptions"
          @change="trigger()"
          @focus="timeQuery = {}"
        ></el-date-picker>
        <el-date-picker
          v-show=" params.range === 'month'"
          v-model="timeQuery.a"
          value-format="yyyy-MM-dd"
          type="monthrange"
          range-separator="至"
          start-placeholder="开始月份"
          end-placeholder="结束月份"
          @change="trigger()"
          @focus="timeQuery = {}"
          :picker-options="pickerOptions"
        ></el-date-picker>
        <el-button
          style="margin-left: 10px;"
          type="primary"
          class="elm-but"
          :loading="loading"
          @click="eliminate"
        >重置</el-button>
      </div>
      <div>
        <div style="margin:0;height:300px;">
          <echarts-line :toilet="data" :serviceType="'bar'"></echarts-line>
        </div>

        <table class="surface" style="margin-top:50px">
          <thead>
            <tr>
              <th>出水总量（吨）</th>
              <th>时间</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in  dataList" :key="index">
              <td>{{item.todayCubic}}</td>
              <td>{{item.today}}</td>
            </tr>
          </tbody>
          <noData :data="data" />
        </table>
      </div>
    </div>
  </div>
</template>


<script>
import noData from "@/components/html/noData";
import echartsLine from "@/components/html/echartsLine.vue";

export default {
  components: {
    noData,
    echartsLine,
  },
  data() {
    return {
      dateQuery: [
        // { name: "分时" },
        { name: "日", value: "day" },
        { name: "周", value: "week" },
        { name: "月", value: "month" },
        { name: "年", value: "year" },
      ],
      timeQuery: {
        a: [],
        b: "",
        c: "",
      },
      pageSize: 10, //每页10条
      pageNum: 1, //当前页码
      data: {
        list: [],
        day: [],
      },
      dataList: [],
      loading: false,
      params: {
        beginTime: null,
        endTime: null,
        range: "day",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如
        },
        firstDayOfWeek: 1,
      },
    };
  },
  methods: {
    getList() {
      this.data = this.$options.data().data
      this.get("waterVacuumCount/selectDrainage", this.params).then((res) => {
        this.dataList =  res.data.data;
        this.dataList.map((e) => {
          this.data.list.push(e.todayCubic);
          this.data.day.push(e.today);
        });
      });
    },
    initTime() {
      this.params.beginTime = this.parseTime(new Date(new Date().getFullYear(), new Date().getMonth(), 1), '{y}-{m}-{d}');
      this.params.endTime = this.parseTime(new Date(), '{y}-{m}-{d}');
    },

    //时间选择
    timeSelection(index) {
      this.params.range = index;
      if (index === "year" ) {
        this.params.beginTime = null;
        this.params.endTime = null;
        this.getList();
      }
      this.timeQuery.a = [];
      this.timeQuery.b = "";
      this.timeQuery.c = "";
    },

    //重置
    eliminate() {
      this.timeQuery = {};
      this.params = this.$options.data().params
      this.initTime();
      this.getList();
    },

    //日期查询
    trigger() {
      if (this.params.range === "week") {
        let a = this.getWeekStartAndEnd(this.timeQuery.b);
        this.params.beginTime = a[0];
        this.params.endTime = a[1];
      } else if (this.params.range === "month") {
        let a = this.timeQuery.a[1];
        let b = a.slice(6);
        let c = a.slice(0, a.length - 2);
        this.params.beginTime = this.timeQuery.a[0];
        this.params.endTime =
          c +
          new Date(
            new Date().getFullYear(),
            b.slice(0, b.length - 3),
            0
          ).getDate();
      } else {
        this.params.beginTime = this.timeQuery.a[0];
        this.params.endTime = this.timeQuery.a[1];
      }
      this.getList();
    },
  },
  mounted() {
    this.initTime();
    this.getList();
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/menu/statisticalReport/vacuumDrainageReport.vue